import React, { Component } from "react";
import { Button, Container, Form } from "react-bootstrap";
import { CheckBox } from 'devextreme-react/check-box';
import{userServices} from "../../services/user.service";
//import notify from 'devextreme/ui/notify';
import PulseLoader from 'react-spinners/PulseLoader';

const UserNameContext = React.createContext('');

export default class Login extends Component { 
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      rememberMe:false,
      errorMessage:"",
      loading: false
    };
    this.onValueChanged = this.onValueChanged.bind(this);
    //userServices.logout();
  }

  onValueChanged(args) {
    this.setState({
      rememberMe: args.value
    });
  }

  validateForm() {
    return this.state.email.length > 0 && this.state.password.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit = event => {
    event.preventDefault();
    try {
      this.setState({loading:true});
      userServices.login(this.state.email, this.state.password, this.state.rememberMe).then(
        data=> {
          userServices.getCurrentUser().then(
            data=>{
              localStorage.setItem('userName', data.userName);
              localStorage.setItem('userId', data.id);
              localStorage.setItem('phoneNumber', data.phoneNumber);
              localStorage.setItem('email', data.email);
              userServices.getRoleByName(data.roles[0]).then(
                role=>{
                  localStorage.setItem('roleType', role.roleType);
                  //notify({position:'top right', message:'Login successfully',type:'success',maxWidth:200});
                  this.setState({loading:false});
                  
                  //When a caregiver logs in and he has not verified their phone number, go to profile UI to  a reminder prompting the caregiver to verify their mobile number.
                  if(role.roleType == 4 && data.phoneNumberConfirmed === false){
                  this.props.history.push('/UserProfile');
                  }else
                  {
                    this.props.history.push('/');
                  }
                },
                error=>{
                  //notify({position:'top right', message:"Unable to get role details. Please try again. "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
                  this.setState({errorMessage:"Unable to get role details. Please try again. "+ error});
                  this.setState({loading:false});
                }
              );
            },
            error=>{
                //notify({position:'top right', message:"Unable to get user details. Please try again. "+ error, type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
                this.setState({errorMessage:"Unable to get user details. Please try again. "+ error});
                this.setState({loading:false});
            }
          );
        },
        error=>{
          //notify({position:'top right', message:'Unable to login. Please check that your email and password is correct.',type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
          if(error!=='')
          {
            var errorDetail = error.split(';');
            if(errorDetail.length>1){
              this.setState({errorMessage:"Unable to login. "+errorDetail[1]});
            }
            else{
              this.setState({errorMessage:"Unable to login. Please check that your email and password is correct."});
            }
          }
          else{
            this.setState({errorMessage:"Unable to login. Please check that your email and password is correct."});
          }
          this.setState({loading:false});
        }
      );
    } catch (error) {
      //notify({position:'top right', message:'Login failed. '+error.message,type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
      this.setState({errorMessage:"Login failed. "+ error.message});
      this.setState({loading:false});
    }
    
  }

  render() {
    return (
      <UserNameContext.Provider value={this.state.email}>
            <div className="Login">
                <form onSubmit={this.handleSubmit}>
                    <h3>Login</h3>
                    <Form.Group controlId="email" bsSize="large">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            autoFocus
                            placeholder="Enter email or username"
                            value={this.state.email}
                            onChange={this.handleChange}
                        />
                    </Form.Group>
                    <Form.Group controlId="password" bsSize="large">
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                            value={this.state.password}
                            onChange={this.handleChange}
                            type="password"
                        />
                    </Form.Group>
                    <Form.Group bsSize="large">
                        <CheckBox
                            value={this.state.rememberMe}
                            text={'Remember me'}
                            onValueChanged={this.onValueChanged}
                            className="form-label"
                        />
                    </Form.Group>
                    <Form.Group bsSize="large">
                        <span style={{ color: "red" }}>{this.state.errorMessage}</span>
                    </Form.Group>
                    <Button
                        block
                        bsSize="large"
                        disabled={!this.validateForm()}
                        type="submit"
                    >
                        Login
            </Button>
                     &nbsp;
                    <Form.Group bsSize="large">
                        <a href="/forgotPassword">Forgot password?</a>
                    </Form.Group>
                    &nbsp;
            <Form.Group bsSize="large">
                        <b><a href="/register" >Don't have an account? Join Now - Free Trial</a></b>
                    </Form.Group>
                </form>
            </div>
            <div className='sweet-loading' style={{ textAlign: "center" }}>
                <PulseLoader
                    color={'#36D7B7'}
                    loading={this.state.loading}
                />
            </div>
      </UserNameContext.Provider>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Login.js